import React from 'react';

const SprintEmptyState = ({ onCreate, backHref }) => {
  return (
    <div className="flex items-center justify-center py-20 px-4">
      <div className="max-w-2xl text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100 text-gray-400">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
          </svg>
        </div>
        <h2 className="text-2xl font-semibold text-gray-900">No Active Sprint</h2>
        <p className="mt-2 text-gray-600">There is no current sprint found.</p>
        <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <a href={backHref} className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
            <svg className="mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5A1 1 0 018.707 4.707L5.414 8H17a1 1 0 110 2H5.414l3.293 3.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            Back to Sprints
          </a>
          <button onClick={onCreate} className="inline-flex items-center rounded-md bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800">
            <span className="mr-2 inline-flex h-2 w-2 items-center justify-center rounded-full border-2 border-white"></span>
            Create New Sprint
          </button>
        </div>
        <div className="mt-8 rounded-md border border-blue-100 bg-blue-50 p-4 text-left">
          <p className="text-sm text-blue-900">
            <span className="font-semibold">Need help?</span> Sprints help you organize and track progress on your action items. You can create focused 90-day sprints to achieve specific objectives.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SprintEmptyState;


